import { render, staticRenderFns } from "./order_history.vue?vue&type=template&id=37a3d2a8"
import script from "./order_history.vue?vue&type=script&lang=js"
export * from "./order_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports